import React, { useState } from "react";
import { Sidebar, Sidenav, Nav } from "rsuite";
import DashboardIcon from "@rsuite/icons/legacy/Dashboard";
import GroupIcon from "@rsuite/icons/legacy/Group";
import TextImageIcon from "@rsuite/icons/TextImage";
import AdminIcon from "@rsuite/icons/Admin";
import ShieldIcon from "@rsuite/icons/Shield";
import LogIcon from "@rsuite/icons/Log";
import ReviewIcon from "@rsuite/icons/Review";
import MenuIcon from "@rsuite/icons/Menu";
import TouchIcon from "@rsuite/icons/Touch";
import CreditCardPlusIcon from "@rsuite/icons/CreditCardPlus";
import "./sidebar.scss";
import { useAuth } from "react-oidc-context";

interface AppSidebarProps {
  onSelect: (key: string) => void;
  expanded?: boolean;
  activePage?: string;
}

const AppSidebar: React.FC<AppSidebarProps> = ({ onSelect, activePage }) => {
  const auth = useAuth();
  const [expanded, setExpanded] = useState(true);

  const userType = auth.user?.profile?.["custom:userType"];
  console.log("userType:", userType);

  // Do not render the sidebar for unauthenticated or mobile users
  if (!auth.isAuthenticated || !auth.user || userType === "mobile") {
    return null;
  }

  return (
    <Sidebar
      style={{ background: "#cce9ff", color: "white" }}
      width={expanded ? 260 : 56}
      collapsible
    >
      <Sidenav
        expanded={expanded}
        style={{ background: "#cce9ff", color: "white" }}
        defaultOpenKeys={["2"]}
        appearance="subtle"
      >
        <Sidenav.Body>
          <Nav activeKey={activePage} onSelect={onSelect}>
            <Nav.Item
              eventKey={activePage}
              onClick={() => setExpanded(!expanded)}
              icon={<MenuIcon />}
            >
              Expand/Collapse
            </Nav.Item>

            <Nav.Item eventKey="dashboard" icon={<DashboardIcon />}>
              Dashboard
            </Nav.Item>
            <Nav.Item eventKey="report-center" icon={<LogIcon />}>
              Report Center
            </Nav.Item>
            <Nav.Item eventKey="payment-gateway" icon={<TouchIcon />}>
              Payment Gateway
            </Nav.Item>

            <Nav.Menu eventKey="2" title="Master" icon={<GroupIcon />}>
              <Nav.Item eventKey="category">Category</Nav.Item>
              <Nav.Menu eventKey="2.1" title="Location">
                <Nav.Item eventKey="zone">Zone</Nav.Item>
                <Nav.Item eventKey="corporate-zone">Corporate Zone</Nav.Item>
              </Nav.Menu>
              <Nav.Menu eventKey="2.2" title="Area">
                <Nav.Item eventKey="district">District</Nav.Item>
                <Nav.Item eventKey="block">Block</Nav.Item>
                <Nav.Item eventKey="counter">Counter</Nav.Item>
                <Nav.Item eventKey="taluk">Taluk</Nav.Item>
                <Nav.Item eventKey="constituency">Constituency</Nav.Item>
                <Nav.Item eventKey="ward">Ward</Nav.Item>
                <Nav.Item eventKey="union">Union</Nav.Item>
                <Nav.Item eventKey="state">State</Nav.Item>
              </Nav.Menu>
              <Nav.Item eventKey="route">Route</Nav.Item>
              <Nav.Item eventKey="routecity">Route City</Nav.Item>
            </Nav.Menu>

            <Nav.Menu eventKey="3" title="Products" icon={<TextImageIcon />}>
              <Nav.Item eventKey="main-group">Main Group</Nav.Item>
              <Nav.Item eventKey="sub-group">Sub Group</Nav.Item>
              <Nav.Item eventKey="uom">UoM</Nav.Item>
              <Nav.Item eventKey="product">Product</Nav.Item>
              <Nav.Item eventKey="producttax">Tax</Nav.Item>
              <Nav.Item eventKey="productavailability">Availability</Nav.Item>
              <Nav.Item eventKey="productprice">Price</Nav.Item>
            </Nav.Menu>

            <Nav.Menu eventKey="4" title="Party" icon={<AdminIcon />}>
              <Nav.Item eventKey="agent">Agent</Nav.Item>
              <Nav.Item eventKey="droppingpoint">Dropping Point</Nav.Item>
              <Nav.Item eventKey="customer">Customer</Nav.Item>
              <Nav.Item eventKey="consumer">Consumer</Nav.Item>
              <Nav.Item eventKey="employee">Employee</Nav.Item>
            </Nav.Menu>

            <Nav.Menu eventKey="5" title="Vehicles" icon={<ShieldIcon />}>
              <Nav.Item eventKey="vehicletype">Type</Nav.Item>
              <Nav.Item eventKey="transport">Transport</Nav.Item>
              <Nav.Item eventKey="vehiclesetup">Setup</Nav.Item>
            </Nav.Menu>

            <Nav.Menu eventKey="6" title="Sales" icon={<ReviewIcon />}>
              <Nav.Item eventKey="agentorder">Agent Orders</Nav.Item>
              <Nav.Item eventKey="agentorderliter">Agent Order(Liter)</Nav.Item>
              <Nav.Item eventKey="consumerorder">Consumer Orders</Nav.Item>
              <Nav.Item eventKey="productinvoice">Product Invoice</Nav.Item>
              <Nav.Item eventKey="prepareindent">Prepare Indent</Nav.Item>
                          <Nav.Item eventKey="employeefreemilk">Employee Freemilk</Nav.Item>
                          <Nav.Item eventKey="dispatch">Dispatch</Nav.Item>

            </Nav.Menu>

            <Nav.Item eventKey="purchase" icon={<CreditCardPlusIcon />}>
              Purchase
            </Nav.Item>
          </Nav>
        </Sidenav.Body>
      </Sidenav>
    </Sidebar>
  );
};

export default AppSidebar;
